import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { normalizeRole } from '../utils/roles';

const RequireRole = ({ allow, children }) => {
  const { user, isAuthenticated, loading: authLoading } = useAuth();

  if (authLoading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  const role = normalizeRole(user?.role);
  if (!Array.isArray(allow) || !allow.includes(role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export default RequireRole;
